import * as React from 'react'
import { useHistory } from 'react-router-dom'
import { authService } from '@oneblink/apps'
import { useAuth } from '@oneblink/apps-react'
import ErrorMessage from 'components/ErrorMessage'
import Loading from 'components/LoadingSpinner'

function LogoutScene() {
  const history = useHistory()
  const [error, setError] = React.useState<Error | null>(null)
  const { isLoggedIn } = useAuth()

  const redirect = React.useCallback(() => {
    console.log('redirecting to /login')
    history.replace('/login')
  }, [history])

  React.useEffect(() => {
    console.log('attempting logout, user is', authService.isLoggedIn())
    const abortController = new AbortController()
    const run = async () => {
      try {
        if (isLoggedIn) {
          await authService.logout()
        }
        redirect()
      } catch (error) {
        console.warn('Error logging out', error)
        if (!abortController.signal.aborted) {
          setError(error as Error)
        }
      }
    }

    run()

    return () => {
      abortController.abort()
    }
  }, [redirect, isLoggedIn])

  return (
    <>
      {error && (
        <>
          <ErrorMessage>{error}</ErrorMessage>
          <button onClick={redirect}>Home</button>
        </>
      )}

      {!error && (
        <Loading>
          <span>Logging Out</span>
        </Loading>
      )}
    </>
  )
}

export default React.memo(LogoutScene)
